import { Icon } from '@benzinga/core-ui';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import React from 'react';

type SubmitProps = {
  isSubmitting: boolean;
  submit: () => void;
  text: string;
};

export const Submit: React.FC<SubmitProps> = ({ isSubmitting, submit, text }) => {
  return (
    <div>
      <button className="btn-cta" onClick={() => submit()} type="button">
        {!isSubmitting && <span className="btn-label">{text}</span>}
        {isSubmitting && (
          <div className="loading-icon">
            <Icon icon={faSpinner} spin={true} />
          </div>
        )}
      </button>
    </div>
  );
};
